import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import api from '../services/api';
import { useAuth } from './auth';

const CompanyContext = createContext({});

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState({});
  const { id_empresa } = useAuth();

  const fetchedId = useRef(null);

  const updateCompany = (newCompany) => {
    setCompany((prevCompany) => ({
      ...prevCompany,
      ...newCompany,
    }));
  };

  useEffect(() => {
    if (!id_empresa || fetchedId.current === id_empresa) {
      return;
    }

    fetchedId.current = id_empresa;

    api
      .get(`empresa/encontrar/${id_empresa}`)
      .then((res) => {
        setCompany(res.data);
      })
      .catch((error) => {
        console.log({ error });
        fetchedId.current = null;
      });

  }, [id_empresa]);

  return (
    <CompanyContext.Provider value={{ company, updateCompany }}>
      {children}
    </CompanyContext.Provider>
  );
};

export function useCompany() {
  const context = useContext(CompanyContext);

  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
}
